/**
 * @flow
 * @relayHash b2c91a70d2bf92b69325aa095cc85681
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cartAddItem_MutationVariables = {|
  input: {
    license_item: {
      track_id?: ?string,
      usages?: ?$ReadOnlyArray<?{
        spot_count?: ?number,
        term?: ?number,
        medium: number,
        contextual_param?: ?$ReadOnlyArray<?number>,
        contextual_param_type: string,
        air_date?: ?any,
      }>,
    },
    clientMutationId?: ?string,
  },
|};
export type cartAddItem_MutationResponse = {|
  +addItem: ?{|
    +cart: ?{|
      +id: string,
      +license_line_items: ?$ReadOnlyArray<?{|
        +id: string,
        +amount: ?number,
        +discount_amount: ?number,
        +track: ?{|
          +id: string,
          +internal_id: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
        |},
        +license: ?{|
          +id: string,
          +usages: ?$ReadOnlyArray<?{|
            +id: string,
            +license_id: ?number,
            +air_date: ?any,
            +components: ?$ReadOnlyArray<?{|
              +id: string,
              +component_id: ?number,
              +name: ?string,
              +type: ?string,
            |}>,
          |}>,
        |},
      |}>,
      +total: ?number,
    |},
  |},
|};
*/


/*
mutation cartAddItem_Mutation(
  $input: AddItemInput!
) {
  addItem(input: $input) {
    cart {
      id
      license_line_items {
        id
        amount
        discount_amount
        track {
          id
          internal_id
          title
          added_to_cart
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
        }
        license {
          id
          usages {
            id
            license_id
            air_date
            components {
              id
              component_id
              name
              type
            }
          }
        }
      }
      total
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddItemInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddItemInput!"
      }
    ],
    "concreteType": "AddItemPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cart",
        "storageKey": null,
        "args": null,
        "concreteType": "Cart",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "license_line_items",
            "storageKey": null,
            "args": null,
            "concreteType": "LicenseLineItem",
            "plural": true,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discount_amount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "track",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": false,
                "selections": [
                  v1,
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "added_to_cart",
                    "args": null,
                    "storageKey": null
                  },
                  v3,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "artist",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Artist",
                    "plural": false,
                    "selections": [
                      v1,
                      v6,
                      v3,
                      v5
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "terms",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTermConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TaxonomyTermEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTerm",
                            "plural": false,
                            "selections": [
                              v1,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "is_highlighted",
                                "args": null,
                                "storageKey": null
                              },
                              v6,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "parent_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "taxonomy",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Taxonomy",
                                "plural": false,
                                "selections": [
                                  v1,
                                  v2,
                                  v6
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "license",
                "storageKey": null,
                "args": null,
                "concreteType": "StandardLicense",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StandardLicenseUsage",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "license_id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "air_date",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "components",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StandardLicenseUsageComponent",
                        "plural": true,
                        "selections": [
                          v1,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "component_id",
                            "args": null,
                            "storageKey": null
                          },
                          v6,
                          v4
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "cartAddItem_Mutation",
  "id": null,
  "text": "mutation cartAddItem_Mutation(\n  $input: AddItemInput!\n) {\n  addItem(input: $input) {\n    cart {\n      id\n      license_line_items {\n        id\n        amount\n        discount_amount\n        track {\n          id\n          internal_id\n          title\n          added_to_cart\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n        }\n        license {\n          id\n          usages {\n            id\n            license_id\n            air_date\n            components {\n              id\n              component_id\n              name\n              type\n            }\n          }\n        }\n      }\n      total\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "cartAddItem_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v7
  },
  "operation": {
    "kind": "Operation",
    "name": "cartAddItem_Mutation",
    "argumentDefinitions": v0,
    "selections": v7
  }
};
})();
(node/*: any*/).hash = '1d167a7b3bde173b4b897d58abad0ef1';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/cartAddItem_Mutation.graphql.js